<template>
  <ul v-if="fabricAndPrintMedia.length > 0" class="fabric-and-print__images">
    <li v-for="reference in fabricAndPrintMedia" :key="reference.id">
      <IntersectionObserver v-slot="{ intersected }">
        <Picture
          v-if="reference.mediaContentType === 'IMAGE'"
          :images="reference.image"
          class="fabric-and-print__media"
          :intersected="intersected"
        />
        <Video
          v-else-if="reference.mediaContentType === 'VIDEO'"
          :video="reference"
          class="fabric-and-print__media"
          :intersected="intersected"
        />
      </IntersectionObserver>
    </li>
  </ul>

  <div class="wysiwyg">
    <p v-for="(paragraph, index) in fabricAndPrintDescription" :key="index">
      {{ paragraph }}
    </p>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { unwrapNodes } from "@/helpers/graphql";
import Video from "@/components/Video.vue";
import Picture from "@/components/Picture.vue";
import IntersectionObserver from "@/components/IntersectionObserver.vue";

export default {
  name: "FabricAndPrint",
  components: {
    Video,
    Picture,
    IntersectionObserver,
  },
  computed: {
    ...mapState("product", ["product"]),
    fabricAndPrintDescription() {
      const str = this.product.fabricAndPrintDescription.value;
      const paragraphs = str.split(/\r?\n/);
      return paragraphs;
    },
    fabricAndPrintMedia() {
      const references =
        unwrapNodes(this.product.fabricAndPrintMedia?.references?.edges) || [];
      return references;
    },
  },
};
</script>

<style lang="scss" scoped>
.fabric-and-print__media {
  max-height: 240px;

  :deep(.image) {
    width: auto;
  }
}

.fabric-and-print__images {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  flex-flow: row nowrap;
  gap: 2px;
  margin-bottom: 20px;

  & > * {
    flex: 1 0 auto;
  }

  :deep(.video__element) {
    height: 240px;
    width: auto;
  }
}

.wysiwyg p {
  @include editorial-body(16px);
}
</style>
